import * as React from 'react';

const MOBILE_BREAKPOINT = 1280;

// Lazy initializer síncrono para evitar CLS: primeiro render já com o breakpoint correto,
// sem depender de effect para hidratar. Ver `use-laptop.ts` para o mesmo padrão.
const getInitialIsMobile = (breakpoint: number): boolean => typeof window !== 'undefined' && window.innerWidth < breakpoint;

export function useIsMobile({ breakpoint = MOBILE_BREAKPOINT }: { breakpoint?: number } = {}) {
  const [isMobile, setIsMobile] = React.useState<boolean>(() => getInitialIsMobile(breakpoint));

  React.useEffect(() => {
    const mql = window.matchMedia(`(max-width: ${breakpoint - 1}px)`);
    const onChange = () => {
      setIsMobile(window.innerWidth < breakpoint);
    };
    mql.addEventListener('change', onChange);
    setIsMobile(window.innerWidth < breakpoint);
    return () => mql.removeEventListener('change', onChange);
  }, [breakpoint]);

  return isMobile;
}
